import { ThemeProvider } from "@mui/material";

import theme from "./theme";

const AppTheme = ({ children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default AppTheme;
